import api from './api';
import { PriceUpdate } from '../types';

export interface CreatePriceUpdateData {
  entity_type: 'customer' | 'lead' | 'tender';
  entity_id: number;
  price: number;
  update_date: string;
  notes?: string;
}

export interface UpdatePriceUpdateData {
  price?: number;
  update_date?: string;
  notes?: string;
}

export interface PriceUpdateFilters {
  entity_type?: 'customer' | 'lead' | 'tender';
  entity_id?: number;
  date_from?: string;
  date_to?: string;
}

export const priceUpdateService = {
  getAll: async (filters?: PriceUpdateFilters): Promise<PriceUpdate[]> => {
    const response = await api.get('/api/price-updates', { params: filters });
    return response.data;
  },

  getById: async (id: number): Promise<PriceUpdate> => {
    const response = await api.get(`/api/price-updates/${id}`);
    return response.data;
  },

  getByEntity: async (entityType: 'customer' | 'lead' | 'tender', entityId: number): Promise<PriceUpdate[]> => {
    const response = await api.get(`/api/price-updates/entity/${entityType}/${entityId}`);
    return response.data;
  },

  getLatestPrice: async (entityType: 'customer' | 'lead' | 'tender', entityId: number): Promise<PriceUpdate | null> => {
    const response = await api.get(`/api/price-updates/latest/${entityType}/${entityId}`);
    return response.data;
  },

  create: async (data: CreatePriceUpdateData): Promise<PriceUpdate> => {
    const response = await api.post('/api/price-updates', data);
    return response.data.price_update;
  },

  update: async (id: number, data: UpdatePriceUpdateData): Promise<PriceUpdate> => {
    const response = await api.put(`/api/price-updates/${id}`, data);
    return response.data.price_update;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/price-updates/${id}`);
  },
};




